export default {
    clubShow: 'Club Show',
    groupShow: 'Group Show',
    newModel: 'New Model',
    privateShow: 'Private Show',
    truePrivateShow: 'TruePrivate',
    location: 'Location',
    age: 'Age',
    away: 'Away',
    viewersInPastMinute: '+{diff} viewers in past minute',
    viewers: 'Viewers',
    pinRoom: 'Pin Room',
    openRoom: 'Open Room',
    unpinRoom: 'Unpin Room',
    openedRoom: 'Opened Room',
    hasNote: 'Has Note',
}
